import { onEachPageTeardown } from '../page-teardown'

export function makePageSingleton<I, A extends unknown[]>(
  createInstance: (...args: A) => I
): (...args: A) => I {
  let instance: I | null

  const resetInstance = (): void => {
    if (
      instance &&
      typeof instance === 'object' &&
      'teardown' in instance &&
      typeof instance.teardown === 'function'
    ) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      instance.teardown()
    }
    instance = null
  }

  onEachPageTeardown(resetInstance)

  const setupInstance = (...args: A): I => {
    instance = createInstance(...args)
    return instance
  }

  const getInstance = (...args: A): I => {
    return instance ? instance : setupInstance(...args)
  }

  return getInstance
}
